var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".salesDash{color:#fff;background-image:url(" + escape(require("../../assets/img/login.jpg")) + ")!important;border:5px solid #fff;border-radius:10px}.salesDash i:hover{cursor:pointer}.card{min-height:140px;max-height:140px}.total{bottom:-15px}.progress-bar{font-size:13px!important}", ""]);

// exports
